import TiltingGateForm from "./TiltingGateForm";

export default TiltingGateForm